import { render, staticRenderFns } from "./VehicleDriver.vue?vue&type=template&id=1b73fdf4&"
import script from "./VehicleDriver.vue?vue&type=script&lang=js&"
export * from "./VehicleDriver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports